export const iconFontAwesomeHouseholdHouseLaptop = (
	<i className="fa-solid fa-house-laptop"></i>
);
